export enum YourTypeEvents {
  PAGE_VIEW = 'YOUR_TYPE:page_view',
  QUIZ_START = 'YOUR_TYPE:quiz_start',
  QUIZ_EXIT = 'YOUR_TYPE:quiz_exit',
  QUIZ_COMPLETE = 'YOUR_TYPE:quiz_complete',
  AUTHWALL_OPEN = 'YOUR_TYPE:authwall_open',
  AUTHWALL_COMPLETED = 'YOUR_TYPE:authwall_completed',
  AUTHWALL_CANCELLED = 'YOUR_TYPE:authwall_cancelled',
  ONBOARDING_REDIRECT = 'YOUR_TYPE:onboarding_redirect',
  ONBOARDING_RETURNED = 'YOUR_TYPE:onboarding_returned',
  LOADING_VIEW = 'YOUR_TYPE:loading_view',
  LOADING_COMPLETE = 'YOUR_TYPE:loading_complete',
  LOADING_EXIT = 'YOUR_TYPE:loading_exit',
  WRAPPED_VIEW = 'YOUR_TYPE:wrapped_view',
  WRAPPED_COMPLETE = 'YOUR_TYPE:wrapped_complete',
  RESULTS_VIEW = 'YOUR_TYPE:results_view',
  CTA_CLICK = 'YOUR_TYPE:cta_click',
  TRADING_GATE_BLOCKED = 'YOUR_TYPE:trading_gate_blocked',
  GET_APP_MODAL_OPEN = 'YOUR_TYPE:get_app_modal_open',
  GET_APP_MODAL_CLOSE = 'YOUR_TYPE:get_app_modal_close',
  GET_APP_ACQUIRED = 'YOUR_TYPE:get_app_acquired',
  GET_APP_DOWNLOAD_CLICK = 'YOUR_TYPE:get_app_download_click',
  GET_APP_TEXT_LINK_ATTEMPT = 'YOUR_TYPE:get_app_text_link_attempt',
  GET_APP_TEXT_LINK_SUCCESS = 'YOUR_TYPE:get_app_text_link_success',
  GET_APP_TEXT_LINK_ERROR = 'YOUR_TYPE:get_app_text_link_error',
}
